import { create } from 'zustand';

/**
 * BLU-373 PR2b: which currency the PO page is displaying.
 *
 * The PO line items are stored in PO currency. The org base currency
 * (typically AUD for Threadheads) is the valuation currency. The toggle
 * lets staff flip between the two without re-fetching anything — every
 * Money component reads from this store and re-renders.
 *
 * Default: 'po' — users open a PO expecting to see what they owe the
 * supplier, in the supplier's currency.
 *
 * Hidden when po.currency === org.default_currency (no toggle needed,
 * the values are identical).
 */

export type DisplayCurrency = 'org' | 'po';

interface CurrencyDisplayState {
  displayCurrency: DisplayCurrency;
  setDisplayCurrency: (currency: DisplayCurrency) => void;
  toggle: () => void;
  /** Reset to default 'po'. Called on OrderDetail mount to prevent cross-PO state leak. */
  reset: () => void;
}

export const useCurrencyDisplayStore = create<CurrencyDisplayState>((set) => ({
  displayCurrency: 'po',
  setDisplayCurrency: (currency) => set({ displayCurrency: currency }),
  toggle: () => set((state) => ({ displayCurrency: state.displayCurrency === 'po' ? 'org' : 'po' })),
  reset: () => set({ displayCurrency: 'po' }),
}));
